import { Box } from '@chakra-ui/react';
import { StickerCategory, useAppStore } from '@halo/chat-sdk-react';
import { useCallback } from 'react';
import { LottieRender } from '../../Editor';

export function StickerTypeIcon({
  sticker_id = '',
  category = StickerCategory.Sticker,
}: {
  sticker_id?: string;
  category?: StickerCategory;
}) {
  const client = useAppStore((state) => state.client);

  const getStickerData = useCallback(async () => {
    return client?.Api.emoji
      .getStickerData({
        sticker_id,
        category,
      })
      .then((res) => {
        return res.render_data;
      });
  }, [client, sticker_id, category]);

  return (
    <Box w={34} h={34}>
      <LottieRender size="100%" getData={getStickerData} />
    </Box>
  );
}
